module.exports = __webpack_public_path__ + "static/media/diamond.cde5659f.png";